import { ISelectType } from "../../../../../components/UI/Inputs/AutoCompleteText";
import { ITicketAutomationReceivedRuleAllowedAction } from "../../../../../services/tasySchedMenu.service";
import { ETasyScheduleTypeCode, IScheduleAppointment } from "../../../model";

const getRule = (
  appointment: IScheduleAppointment,
  allowedAction?: ITicketAutomationReceivedRuleAllowedAction | null,
) => {
  if (!allowedAction) return null;

  if (appointment.tasyScheduleTypeCode === ETasyScheduleTypeCode.EXAM) {
    return allowedAction.examTicketAutomationReceivedRule;
  }

  return allowedAction.consultationTicketAutomationReceivedRule;
};

export const getCancellationReasonOptions = (
  appointment: IScheduleAppointment,
  allowedAction?: ITicketAutomationReceivedRuleAllowedAction | null,
): ISelectType[] | undefined => {
  const rule = getRule(appointment, allowedAction);

  return rule?.ticketAutomationReceivedRuleCancelationReasons?.map(
    (reason) => ({
      id: reason.id,
      code: reason.externalId,
      name: reason.externalName,
    }),
  );
};
